import {
  LOAD_CONFIGURATION,
  LOAD_CONFIGURATION_ERROR,
  LOAD_CONFIGURATION_SUCCESS,
  LOAD_QUOTES,
  LOAD_QUOTES_ERROR,
  LOAD_QUOTES_SUCCESS,
  SET_QUOTE_EDIT,
} from '../constants/custom-quotes';

const CUSTOM_QUOTES_INIT = {
  msg: '',
  assets: [],
  quotes: [],
  strategies: [],
  quoteEdit: null,
  loadingQuotes: false,
  loadingConfiguration: false,
  loadingError: false,
};

export default (state = CUSTOM_QUOTES_INIT, action) => {
  switch (action.type) {
    case LOAD_CONFIGURATION:
      return {
        ...state,
        loadingConfiguration: true,
        loadingError: false,
      };
    case LOAD_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loadingConfiguration: false,
        loadingError: false,
        assets: action.assets,
        strategies: action.strategies,
      };
    case LOAD_CONFIGURATION_ERROR:
      return {
        ...state,
        loadingConfiguration: false,
        loadingError: false,
      };
    case LOAD_QUOTES:
      return {
        ...state,
        loadingQuotes: true,
        loadingError: false,
      };
    case LOAD_QUOTES_SUCCESS:
      return {
        ...state,
        quoteEdit: null,
        loadingQuotes: false,
        loadingError: false,
        quotes: action.quotes,
        msg: action?.msg || '',
      };
    case LOAD_QUOTES_ERROR:
      return {
        ...state,
        loadingQuotes: false,
        loadingError: false,
      };
    case SET_QUOTE_EDIT:
      return {
        ...state,
        quoteEdit: action.quote
      };
    default:
      return state;
  }
};
